<template>
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon/General/NoteRemove">
        <path
          id="NoteRemove_icon"
          d="M19 14C19.7 14 20.37 14.13 21 14.35V10L15 4H5C3.89 4 3 4.89 3 6V20C3 21.11 3.9 22 5 22H13.35C13.13 21.37 13 20.7 13 20C13 16.69 15.69 14 19 14ZM14 5.5L19.5 11H14V5.5ZM20.41 20L22.54 22.12L21.12 23.54L19 21.41L16.88 23.54L15.47 22.12L17.59 20L15.47 17.88L16.88 16.47L19 18.59L21.12 16.47L22.54 17.88L20.41 20Z"
          fill="black"
        />
      </g>
    </svg>
  </template>
  
  <script>
  export default {
    name: "NoteRemoveIcon"
  };
  </script>
  